// All site content in one place for easy maintenance

export const company = {
  name: 'Pulmakivi',
  tagline: 'Suomalaisia mobiilipelejä',
  description: `Pulmakivi on helsinkiläinen mobiilipeliyritys, joka kehittää tällä hetkellä Norppa-ristikkosovellusta suomenkieliselle yleisölle.`,
  email: 'tuki@pulmakivi.fi',
};

export const norppa = {
  name: 'Norppa',
  tagline: 'Ristikot taskussasi',
  description: `Norppa on ristikkopeli, joka tuo klassisen
    sanaristikon älypuhelimeesi. Ratkaise satoja ristikoita missä ja milloin vain!`,
  features: [
    'Satoja suomenkielisiä ristikoita',
    'Uusi ristikko päivittäin',
    'Pelaa offline-tilassa',
    'Selkeä ja helppokäyttöinen',
  ],
  googlePlayUrl: 'https://play.google.com/store/apps/details?id=com.norppa.crossword',
  platforms: {
    android: 'Saatavilla Androidille',
    ios: 'iOS-versio tulossa',
  },
};

export const faqs = [
  {
    question: 'Miten voin antaa palautetta?',
    answer: 'Voit antaa palautetta tai ehdottaa uusia ominaisuuksia lähettämällä viestiä sähköpostiosoitteeseen tuki@pulmakivi.fi. Luemme kaikki viestit ja arvostamme palautettasi!',
  },
  {
    question: 'Miten voin perua tilaukseni?',
    answer: 'Sovelluksen tilaukset käsitellään Google Playn toimesta. Tilauksen voi perua [Google Play-kaupasta](https://play.google.com/store/account/subscriptions). Google Play käsittelee myös mahdolliset hyvityspyynnöt virhetilanteissa.',
  },
  {
    question: 'Miten voin poistaa käyttäjätilini?',
    answer: 'Käyttäjätilin voi poistaa helposti sovelluksen sisällä, menemällä sisäänkirjautuneena tiliasetuksiin ja valitsemalla "Poista tili". Voit pyytää myös tietojesi poistoa olemalla yhteydessä asiakastukeen. Tilin poisto ei peru tilauksia.',
  },
  {
    question: 'Peli ei toimi oikein, mitä teen?',
    answer: 'Kokeile ensin käynnistää sovellus tai puhelimesi uudelleen. Jos ongelma jatkuu, lähetä meille viesti osoitteeseen tuki@pulmakivi.fi ja kuvaile ongelma mahdollisimman tarkasti.',
  },
];

export const privacyPolicy = {
  lastUpdated: '23.11.2025',
  sections: [
    {
      title: 'Yleistä',
      content: `Tämä tietosuojakäytäntö koskee Pulmikas (Y-tunnus: 3199117-7, "me", "meidän") kehittämää Norppa-sovellusta ("Sovellus"). Suhtaudumme yksityisyytesi suojaamiseen vakavasti. Sovellus ei ole tarkoitettu alle 16-vuotiaille ilman huoltajan suostumusta.`,
    },
    {
      title: 'Kerättävät tiedot',
      content: `Keräämme seuraavia tietoja:

        • Tilitiedot: sähköpostiosoite, näyttönimi ja Google-profiilin perustiedot (kirjautuessa)
        • Pelitiedot: edistyminen, suoritusajat ja tilastot
        • Tilaustiedot: tilaustyyppi, voimassaolo ja maksualusta
        • Laitetunnisteet: Android Advertising ID ja anonyymi laitetunnus
        • Käyttötiedot: sovelluksen käyttö ja suorituskyky
        • Kaatumisilmoitukset: anonymisoituja teknisiä tietoja virheiden korjaamiseksi`,
    },
    {
      title: 'Käsittelyn oikeusperuste',
      content: `Käsittelemme tietojasi seuraavilla perusteilla:

        • Sopimuksen täyttäminen: käyttäjätilin hallinta, peliedistyminen, tilaukset
        • Oikeutettu etu: analytiikka, kaatumisilmoitukset, sovelluksen kehittäminen
        • Suostumus: personoidut mainokset`,
    },
    {
      title: 'Tietojen käyttö',
      content: `Käytämme tietoja:

        • Käyttäjätilin hallintaan ja kirjautumiseen
        • Peliedistymisen tallentamiseen ja synkronointiin
        • Tilausten hallintaan ja todentamiseen
        • Sovelluksen kehittämiseen ja virheiden korjaamiseen
        • Mainosten näyttämiseen`,
    },
    {
      title: 'Kolmannet osapuolet',
      content: `Sovellus käyttää kolmannen osapuolen palveluja, jotka keräävät tietoja itsenäisesti omien tietosuojakäytäntöjensä mukaisesti:`,
      links: [
        { name: 'Google Play Services', url: 'https://www.google.com/policies/privacy/' },
        { name: 'Google AdMob', url: 'https://support.google.com/admob/answer/6128543' },
        { name: 'Google Analytics for Firebase', url: 'https://firebase.google.com/support/privacy' },
        { name: 'Firebase Crashlytics', url: 'https://firebase.google.com/support/privacy/' },
      ],
      contentAfterLinks: `EU-käyttäjiltä pyydetään suostumus personoituihin mainoksiin. Voit hallita mainostunnistetta Androidin asetuksista (Asetukset > Google > Mainokset).`,
    },
    {
      title: 'Tietojen luovutus',
      content: `Voimme luovuttaa tietoja:

        • Lain vaatiessa (esim. viranomaispyyntö, oikeudellinen prosessi)
        • Oikeuksiemme suojaamiseksi tai petosten tutkimiseksi
        • Luotetuille palveluntarjoajille, jotka toimivat puolestamme ja noudattavat tätä käytäntöä`,
    },
    {
      title: 'Tietojen siirto ja säilytys',
      content: `Tiedot tallennetaan Googlen Firebase-palveluun (EU/USA). Kansainväliset siirrot perustuvat Googlen vakiosopimuslausekkeisiin (Standard Contractual Clauses). Tiedot säilytetään tilin voimassaolon ajan. Tilin poiston yhteydessä tiedot poistetaan heti, mutta ne saattavat säilyä varmuuskopioissamme vielä kuukauden ajan.`,
    },
    {
      title: 'Oikeutesi (GDPR)',
      content: `Sinulla on oikeus:

        • Saada pääsy tietoihisi ja ladata ne (sovelluksen asetuksista)
        • Pyytää tietojesi oikaisua tai poistamista
        • Peruuttaa suostumus personoituihin mainoksiin milloin tahansa
        • Poistaa tilisi ja kaikki tietosi sovelluksen asetuksista
        • Tehdä valitus Tietosuojavaltuutetun toimistoon (tietosuoja.fi)

        Voit hallinnoida kaikkia tietojasi suoraan sovelluksen tiliasetuksista.`,
    },
    {
      title: 'Muutokset ja yhteydenotto',
      content: `Päivitämme käytäntöä tarvittaessa ja ilmoitamme merkittävistä muutoksista sovelluksessa.

        Tietosuojaa koskevat kysymykset: tuki@pulmakivi.fi`,
    },
  ],
};

export const termsOfService = {
  lastUpdated: '23.11.2025',
  sections: [
    {
      title: 'Palvelun kuvaus',
      content: `Norppa on Pulmikas-yrityksen tarjoama ristikko- ja sanapelisovellus. Käyttämällä sovellusta hyväksyt nämä käyttöehdot.`,
    },
    {
      title: 'Käyttäjätili',
      content: `Voit käyttää sovellusta vieraskäyttäjänä tai kirjautua sähköpostilinkillä tai Google-tilillä. Kirjautuminen mahdollistaa edistymisen synkronoinnin ja tilausten hallinnan. Olet vastuussa tilisi turvallisuudesta.`,
    },
    {
      title: 'Tilaukset',
      content: `Sovellus tarjoaa kuukausi- ja vuositilauksia, jotka sisältävät 7 päivän ilmaisen kokeilujakson. Tilaukset käsitellään Google Playn kautta. Tilaus uusiutuu automaattisesti, ellei sitä peruuteta vähintään 24h ennen jakson päättymistä. Peruutus ja palautukset: Google Play -tilaushistoria.`,
    },
    {
      title: 'Käyttäjän velvollisuudet',
      content: `Sitoudut käyttämään sovellusta laillisesti, olemaan kiertämättä teknisiä rajoituksia, kopioimatta sisältöä ja olemaan käyttämättä automatisoituja järjestelmiä.`,
    },
    {
      title: 'Mainokset',
      content: `Sovellus sisältää mainoksia (Google AdMob). Emme vastaa mainosten sisällöstä.`,
    },
    {
      title: 'Immateriaalioikeudet',
      content: `Kaikki sovelluksen sisältö (grafiikka, ristikot, ohjelmisto) on Pulmakiven omaisuutta ja suojattu tekijänoikeuslailla. Et saa kopioida, muokata tai levittää sisältöä.`,
    },
    {
      title: 'Tilin lopettaminen',
      content: `Voimme sulkea tai rajoittaa tiliäsi, jos rikot näitä ehtoja. Voit itse poistaa tilisi milloin tahansa sovelluksen asetuksista.`,
    },
    {
      title: 'Vastuunrajoitus',
      content: `Sovellus tarjotaan "sellaisena kuin se on". Emme takaa keskeytyksetöntä toimintaa emmekä vastaa epäsuorista vahingoista. Vastuumme rajoittuu maksettuihin tilausmaksuihin.`,
    },
    {
      title: 'Muutokset ja riidat',
      content: `Voimme päivittää ehtoja ja ilmoitamme merkittävistä muutoksista. Sovellettava laki: Suomi. Riidat ratkaistaan Suomen tuomioistuimissa. Yhteydenotot: tuki@pulmakivi.fi`,
    },
  ],
};
